import { states } from '@/constants/lifecycle';

const cohortRequestStatus = ({ requests }, {
  status,
  isEditing,
  isDirty,
  validationErrors,
  readStatus,
}) => ({
  accessRequestAllowed: requests.create,
  accessRequestDisabled: !!isDirty || readStatus === states.PENDING || isEditing || validationErrors?.length,
  accessRequestSupported: status.request_enabled.supported,
  accessRequestUnsupportedReasons: status.request_enabled.reasons,
});

const cohortConditionsStatus = ({ status }) => ({
  hasConditions: status.conditional_access?.supported,
});

const cohortStatus = ({ permissions }, cohort) => ({
  ...cohortRequestStatus(permissions, cohort),
  ...cohortConditionsStatus(cohort),
});

export default cohortStatus;
